export const CURRENT_ATTRIBUTION_CONTRACT = 'current-portfolio-attribution.v1';
export const PORTFOLIO_HISTORY_CONTRACT = 'portfolio-history-attribution.v2';
export const isPortfolioAttribution = (data) => [CURRENT_ATTRIBUTION_CONTRACT, PORTFOLIO_HISTORY_CONTRACT].includes(data?.calculation_contract);
const COLORS = ['#ef5350', '#ab47bc', '#5c6bc0', '#42a5f5', '#26a69a', '#66bb6a', '#c0ca33', '#ffa726', '#8d6e63', '#ec407a', '#7e57c2', '#29b6f6'];
export function factorColor(factor, model = '') {
    let hash = 2166136261;
    for (const char of `${model}:${factor}`) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
    return COLORS[(hash >>> 0) % COLORS.length];
}
export function contributionValue(component, mode = 'percent') {
    const value = component?.[mode === 'percent' ? 'contribution_pct' : 'contribution_dollar'];
    return Number.isFinite(value) ? value : null;
}
export function formatContribution(value, mode = 'percent', currency = null) {
    if (!Number.isFinite(value)) return 'Unavailable';
    if (mode === 'percent') return `${value > 0 ? '+' : ''}${(value * 100).toFixed(2)}%`;
    if (currency === 'USD') return `${value < 0 ? '-' : value > 0 ? '+' : ''}$${Math.abs(value).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
    return `${value > 0 ? '+' : ''}${currency || ''} ${value.toLocaleString(undefined, { maximumFractionDigits: 2 })}`.trim();
}
export function boundedLookback(lookback, cap) {
    if (!cap || !/^\d{4}-\d{2}-\d{2}\.\.\d{4}-\d{2}-\d{2}$/.test(lookback || '')) return lookback;
    const [start, end] = lookback.split('..');
    return `${start > cap ? cap : start}..${end > cap ? cap : end}`;
}
export function attributeScopePayload(card) {
    return card?.scope === 'attribute' ? {
        attribute_definition_id: card.attributeDefinitionId,
        attribute_group: card.attributeGroup,
        watchlist_revision_id: card.watchlistRevisionId,
        attribute_definition_fingerprint: card.attributeDefinitionFingerprint,
        attribute_content_fingerprint: card.attributeContentFingerprint,
    } : {};
}

const CAPABILITY_EXPLANATIONS = {
    security_provider_mapping_missing: 'Some current holdings lack an exact security-return mapping for the selected factor dataset.',
    security_history_missing: 'Daily security-return history is missing for some current holdings.',
    security_observations_incomplete: 'Some current holdings are missing security returns on required dates in this window.',
    security_observations_invalid: 'Some security-return observations are duplicated or invalid.',
    security_return_basis_unverified: 'The security returns’ currency, dividend or corporate-action conventions have not been verified against the factor model.',
    security_fx_history_missing: 'Historical currency-conversion rates are missing for some required dates. Total and residual returns need those rates as well as security returns.',
    security_calendar_unverified: 'The expected security-return dates have not been verified for this window.',
    return_currency_mismatch: 'The return currencies are incompatible with each other or the portfolio’s reporting currency.',
    context_changed: 'The portfolio or source inputs changed. Refresh the analysis.',
};
export function capabilityExplanation(capability) {
    return capability?.message || CAPABILITY_EXPLANATIONS[capability?.reason_code] || 'Compatible complete security returns are not available for this portfolio and window.';
}


export const isReferenceWeightHistory = (data) => data?.denominator?.kind === 'current_reference_gross_market_value';
export const isSnapshotExposureHistory = (data) => data?.analysis_basis === 'selected_snapshot_exposures_only';
export const contributionBasisLabel = (data) => isReferenceWeightHistory(data) ? 'current reference portfolio gross market value' : data?.calculation_contract === PORTFOLIO_HISTORY_CONTRACT ? 'opening portfolio gross market value' : 'portfolio gross notional';
export function syntheticHistoryFallbackReason(data) {
    if (data?.basis_resolution?.requested !== 'synthetic' || data?.basis_resolution?.selected !== 'constant'
        || data?.source?.kind !== 'constant_portfolio.v1'
        || !['reference_weight_factor_projection', 'selected_snapshot_exposures_only'].includes(data?.analysis_basis)) return null;
    return data.basis_resolution.reasons?.find((reason) => reason?.reason_code === 'synthetic_history_inputs_unavailable') || null;
}
export const isHistoryContextConflict = (error) => ['context_changed', 'portfolio_history_context_changed', 'synthetic_history_context_changed'].includes(error?.code);
